import React from 'react'
import { Container, Col, Row } from "react-bootstrap";
import "./ProductWhyMutualFund.css";
function ProductWhymutualFund() {
  return (
    <>
    <section className="why-mutual-block">
      <Container className="add-border">
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="why-mutual-inn">
              <h3>
                <span>Why Mutual Fund?</span>
              </h3>
              <p>
              The main advantage of investing in equity investment is the possibility of increasing the principal amount invested. Equity investing has potential of providing inflation adjusted positive return Y-O-Y (through capital gains and dividends) with greater liquidity and tax benefits. An equity fund provides investors with a diverse investment option for a small initial investment. To reach the same level of diversification as an equity portfolio, an investor would need to invest much more manually.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  </>
  )
}
export default ProductWhymutualFund;
